































import Vue from 'vue';
import Component from 'vue-class-component';
import { UserModule } from '@/store/modules/User';
import router from '@/router';

@Component
export default class Login extends Vue {
	private token: string | null = null;

	private async handleLogin() {
		if (this.token != null) {
			try {
				UserModule.loginUser(this.token);
			} catch (ex) {
				// TODO Error handling
			}
		} else {
			alert('Please enter code to log in');
		}
	}
}
